import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { formatPeriodLabel, formatMetric } from "@/lib/format";

const CustomTooltip = ({ active, payload, label, type, dataKey }) => {
  if (!active || !payload || !payload.length) return null;
  return (
    <div data-testid={`metric-trend-tooltip-${dataKey}`} className="rounded-lg border bg-card px-3 py-2 shadow-[var(--shadow-sm)]">
      <div className="text-xs font-medium text-muted-foreground">{formatPeriodLabel(label)}</div>
      <div className="h-display text-sm font-semibold text-foreground">{formatMetric(type, payload[0].value)}</div>
    </div>
  );
};

export const TrendChart = ({ data, dataKey, type = "number", height = 240, color = "hsl(var(--chart-1))" }) => {
  const chartData = (data || []).map((d) => ({ period: d.period, value: d[dataKey] === null || d[dataKey] === undefined ? null : Number(d[dataKey]) }));
  const gradId = `grad-${dataKey}`;
  return (
    <div data-testid={`metric-trend-chart-${dataKey}`} style={{ width: "100%", height }}>
      <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 600, height }}>
        <AreaChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.22} />
              <stop offset="100%" stopColor={color} stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="period" tickFormatter={formatPeriodLabel} tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 12 }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 12 }} axisLine={false} tickLine={false} width={48} tickFormatter={(v) => formatMetric(type, v)} />
          <Tooltip content={<CustomTooltip type={type} dataKey={dataKey} />} />
          <Area type="monotone" dataKey="value" stroke={color} strokeWidth={2} fill={`url(#${gradId})`} connectNulls isAnimationActive={false} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
